import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';

// --- Keyframe Animations ---
const spinAnimation = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const radialFadeAnimation = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
`;

// --- Styled Components ---
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;    
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999999;
  flex-direction: column;
  gap: 20px;
`;

const SpinnerWrapper = styled.div`
  position: relative;
  width: ${props => props.type === 'radial' ? '30px' : '70px'};
  height: ${props => props.type === 'radial' ? '30px' : '70px'};
  display: flex;
  justify-content: center;
  align-items: center;
`;

// --- Default Spinner Styles ---
const DefaultSpinnerBackground = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border-radius: 50%;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
`;

const Spinner = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  border: 6px solid #e0e0e0;
  border-top-color: ${props => props.spinnerColor}; 
  border-radius: 50%;
  animation: ${spinAnimation} 1.5s linear infinite;
`;

const InnerIcon = styled.div`
  position: absolute;
  width: 60%; 
  height: 60%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// --- Radial Spinner Styles ---
const RadialSpinnerWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const RadialBar = styled.div`
  width: 8%;
  height: 24%;
  background-color: #000;
  border-radius: 5px;
  position: absolute;
  left: 46%;
  top: 38%;
  transform-origin: 50% 100%;
  animation: ${radialFadeAnimation} 1.2s linear infinite;
  transform: rotate(${props => props.rotate}deg) translateY(-100%);
  animation-delay: ${props => props.delay}s;
`;

const LoadingText = styled.p`
  color: #2d2d2d;
  font-size: 1.2rem;
  font-weight: 500;
  margin: 0;
`;


const LoadingSpinner = ({ isLoading, type = 'default', text, showImage = false }) => {
    const [spinnerColor, setSpinnerColor] = useState('#85B33E');

    useEffect(() => {
        try {
          const primaryColor = localStorage.getItem("primaryColor");
          if (primaryColor) {
            setSpinnerColor(primaryColor);
          }
        } catch (error) {
          console.error("Could not access localStorage:", error);
        }
      }, []);
    
      if (!isLoading) {
        return null;
      }
      const renderSpinner = () => {
        if (type === 'radial') {
          return (
            <RadialSpinnerWrapper>
              {[...Array(12)].map((_, i) => (
                <RadialBar key={`bar-${i}`} rotate={i * 30} delay={i * 0.1 - 1.2} />
              ))}
            </RadialSpinnerWrapper>
          );
        }
    
        // Default spinner
        return (
          <>
            <DefaultSpinnerBackground />
            <Spinner spinnerColor={spinnerColor} />
            {showImage && (
                <InnerIcon>
                    <svg width="100%" height="100%" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="20" y="20" width="25" height="25" rx="3" fill="#3A3A3A"/>
                        <rect x="55" y="20" width="25" height="25" rx="3" fill="#3A3A3A"/>
                        <rect x="20" y="55" width="25" height="25" rx="3" fill={spinnerColor}/>
                        <rect x="55" y="55" width="25" height="25" rx="3" fill={spinnerColor}/>
                    </svg>
                </InnerIcon>
            )}
          </>
        );
      };

    return (
        <Overlay>
          <SpinnerWrapper>
            {renderSpinner()}
          </SpinnerWrapper>
          {text && <LoadingText>{text}</LoadingText>}
        </Overlay>
      );
};

export default LoadingSpinner;